import { Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const Parking_Sign: React.FC<Props> = ({ fill }) => {
    return (
        <Svg fill={fill} height="100%" viewBox="-61 0 512 512" width="12pt">
            <Path d="m225 166c0-8.277344-6.722656-15-15-15h-30v30h30c8.277344 0 15-6.722656 15-15zm0 0" />
            <Path d="m195 301c57.890625 0 105-47.109375 105-105s-47.109375-105-105-105-105 47.109375-105 105 47.109375 105 105 105zm-45-180h60c24.8125 0 45 20.1875 45 45s-20.1875 45-45 45h-30v60h-30zm0 0" />
            <Path d="m195 512 155.902344-198.871094.175781-.21875c25.460937-33.925781 38.921875-74.355468 38.921875-116.910156 0-107.519531-87.480469-196-195-196s-195 88.480469-195 196c0 42.554688 13.460938 82.984375 39.097656 117.128906zm0-451c74.441406 0 135 60.558594 135 135s-60.558594 135-135 135-135-60.558594-135-135 60.558594-135 135-135zm0 0" />
        </Svg>
    );
};
export default Parking_Sign;
